import React from "react";
import styled from "styled-components";

const CategoryMiniCard = ({
  title = "Customer Experience",
  badge = "CX",
  image,
  onClick
}) => {
  return (
    <Card image={image} onClick={onClick}>
      <Overlay>
        <Title>{title}</Title>
        <Badge>{badge}</Badge>
      </Overlay>
    </Card>
  );
};

export default CategoryMiniCard;

const Card = styled.div`
  width: 260px;
  height: 120px;
  border-radius: 16px;
  background-image: url(${(p) => p.image});
  background-size: cover;
  background-position: center;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  transition: all 0.25s ease;

  &:hover {
    transform: translateY(-4px);
    box-shadow: 0 12px 25px rgba(0, 0, 0, 0.25);
  }
`;

const Overlay = styled.div`
  position: absolute;
  inset: 0;
  padding: 16px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  background: linear-gradient(
    to right,
    rgba(0, 0, 0, 0.6),
    rgba(0, 0, 0, 0.2)
  );
`;

const Title = styled.h3`
  color: #fff;
  font-size: 15px;
  font-weight: 600;
  margin: 0;
  line-height: 1.2;
`;

const Badge = styled.span`
  width: fit-content;
  padding: 4px 10px;
  font-size: 12px;
  font-weight: 500;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.9);
  color: #333;
`;